<template>
  <v-flex xs12>
    <v-layout
      class="pa-4 grey-fill"
      wrap
    >
      <v-flex
        v-if="label"
        xs12
      >
        <p class="f-2 fw-600 text-xs-right text-dark mb-2">
          {{ label }}
        </p>
      </v-flex>
      <v-flex xs12>
        <p class="f-28 fw-600 mb-0 text-xs-right text-dark">
          {{ Number(totalAmount).toFixed(2) | currency }}
        </p>
      </v-flex>
    </v-layout>
  </v-flex>
</template>
<script>
import filters from '@/constants/filters';

export default {
    name: 'ExpensesSummary',
    filters: {
        ...filters
    },
    props: {
        label: {
            type: String,
            default: ''
        },
        totalAmount: {
            type: [String, Number],
            default: 0
        }
    }
};
</script>
<style></style>
